<template>
  <div>
    <div class="page_title">用户积分记录</div>
    <div style="padding: 20px">
      <div class="container">
        <div class="searchbox">
          <div class="item">
            <span>手机号</span>
            <el-input
              v-model="phone"
              style="width: 140px; margin-left: 6px"
              clearable
              @input="search"
            ></el-input>
          </div>
          <div class="item">
            <span>用户昵称</span>
            <el-input
              v-model="nick_name"
              style="width: 140px; margin-left: 6px"
              clearable
              @input="search"
            ></el-input>
          </div>
          <div class="item">
            <span>当前积分</span>
            <el-input-number
              v-model="min_integral"
              :min="1"
              :controls="false"
              style="width: 90px; margin-left: 6px"
            ></el-input-number>
            <span> - </span>
            <el-input-number
              v-model="max_integral"
              :min="1"
              :controls="false"
              style="width: 90px"
            ></el-input-number>
            <el-button
              type="info"
              style="
                background-color: #eceff2;
                color: #747981;
                margin-left: 6px;
              "
              @click="search"
              >查询</el-button
            >
            <el-button type="primary" @click="topage">积分发放情况</el-button>
          </div>
        </div>
        <div class="pricebox">
          <div class="price">
            <div class="priceitem">
              <div class="gray">当前积分总计</div>
              <div class="num">{{ total_integral }}</div>
            </div>
            <div class="priceitem">
              <div class="gray">已用积分总计</div>
              <div class="num">{{ total_use_integral }}</div>
            </div>
            <div class="priceitem">
              <div class="gray">失效积分总计</div>
              <div class="num">{{ total_expire_integral }}</div>
            </div>
          </div>
        </div>

        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
            @sort-change="sortChange"
          >
            <el-table-column label="手机号 " prop="phone"></el-table-column>
            <el-table-column label="用户昵称" prop="nick_name">
            </el-table-column>
            <el-table-column
              label="注册时间"
              prop="reg_time"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              label="当前积分"
              prop="integral"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              label="已用积分"
              prop="use_integral"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              label="失效积分"
              prop="expire_integral"
              sortable="custom"
            ></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="toDetail(scope.row.user_id)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('980')
                      : false
                  "
                  >查看明细</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="padding-top: 20px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
export default {
  data() {
    return {
      totalNum: 0,
      currentPage: 1,
      pagesize: 10,
      tableData: [],
      phone: "",
      nick_name: "",
      min_integral: undefined,
      max_integral: undefined,
      doctor_total: "",
      total_integral: "",
      total_use_integral: "",
      total_expire_integral: "",
      is_test: 2,
      prop: "",
      order_by: "",
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  methods: {
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        phone: this.phone,
        nick_name: this.nick_name,
        min_integral: this.min_integral,
        max_integral: this.max_integral,
        prop: this.prop,
        order_by: this.order_by,
      };
      this.axios
        .post("platform/Integral/getUserIntegralList", data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list.map((item) => {
              item.reg_time = dayjs
                .unix(item.reg_time)
                .format("YYYY-MM-DD HH:mm");
              return item;
            });
            this.total_integral = res.data.total_integral;
            this.total_use_integral = res.data.total_use_integral;
            this.total_expire_integral = res.data.total_expire_integral;
            this.totalNum = res.data.total;
          }
        });
    },
    sortChange(e) {
      let order = e.order;
      this.prop = e.prop;
      if (order == "descending") {
        this.order_by = "desc";
      } else if (order == "ascending") {
        this.order_by = "asc";
      } else {
        this.prop = "";
        this.order_by = "";
      }
      this.getList();
    },
    //查看详情
    toDetail(user_id) {
      this.$router.push({
        path: "integradetail",
        query: {
          user_id,
        },
      });
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //翻页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    topage() {
      this.$router.push({
        path: "/home/integralmanage/pointDistribution",
      });
    },
  },
  activated() {
    this.getList();
  },
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.searchbox {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
  align-items: center;
  box-sizing: border-box;
  .item {
    margin-right: 20px;
  }
}
.pricebox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;
  border: solid 1px #cfcece;
  border-radius: 2px;
  margin-bottom: 12px;
  .price {
    display: flex;
    align-items: center;
    .priceitem {
      border-right: solid 1px #e1e3e9;
      display: flex;
      align-items: center;
      padding: 0 30px;
    }
    .priceitem:before {
      content: "";
    }
  }
  .gray {
    font-size: 12px;
    color: #747981;
  }
  .num {
    font-size: 22px;
    font-weight: 600;
    margin-left: 20px;
  }
}
</style>
